export default __webpack_public_path__ + "static/LeituraTwo-Bold-ebc9d8a39311b9a3e6332e0e58822acd.woff2";